<template>
  <fields-group
    :loading="loading"
    label="Подключенные устройства"
    class="kkmserver-unit-info"
  >
    <div
      v-if="error"
      class="kkmserver-unit-info__error font-weight-medium color-red"
    >
      {{ error }}
      <!-- <v-btn
        class="ml-3"
        depressed
        small
        @click="loadKkmServerUnits"
      >
        Повторить
      </v-btn>-->
    </div>
    <div
      v-else-if="kkmServerUnits.length"
      class="print-server-settings__units_list"
    >
      <div class="kkmserver-unit-info__list">
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">
                Номер устройства
              </th>
              <th class="text-left">
                Название
              </th>
              <th class="text-left">
                Тип
              </th>
              <th class="text-left">
                Версия ФД
              </th>
              <th class="text-left">
                Система налогообложения
              </th>
              <th class="text-left">
                Активность
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="unit in kkmServerUnits" :key="unit.NumDevice">
              <td>{{ unit.NumDevice }}</td>
              <td>{{ unit.NameDevice }}</td>
              <td>{{ unit.TypeDevice }}</td>
              <td>
                <v-progress-circular
                  v-if="getKktState(unit).loading"
                  indeterminate
                  size="16"
                  width="2"
                />
                <template v-else>
                  {{ getFfdVersion(unit) || '—' }}
                  <div
                    v-if="getKktState(unit).error"
                    class="kkmserver-unit-info__hint color-red"
                    :title="getKktState(unit).error"
                  >
                    ККТ не ответила, данные из списка устройств
                  </div>
                </template>
              </td>
              <td>
                <v-progress-circular
                  v-if="getKktState(unit).loading"
                  indeterminate
                  size="16"
                  width="2"
                />
                <template v-else>
                  <v-chip
                    v-for="(v, i) in getTaxVariants(unit)"
                    :key="i"
                    class="kkmserver-unit-info__tax-item mr-2 mb-1 mt-1"
                    small
                  >
                    {{ v }}
                  </v-chip>
                </template>
              </td>
              <td>
                <span v-if="unit.Active" class="color-green">
                  <font-awesome-icon
                    icon="check"
                  /></span>
                <span v-else class="color-red">
                  <font-awesome-icon icon="times" />
                </span>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
    <div v-else class="font-weight-medium">
      Нет подключенных устройств
    </div>
  </fields-group>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'
  import kkmServerApiClient from '@/services/kkm-server/kkmServerApiClient'
  import TaxVariant from '@/models/enums/kkm-server/TaxVariant'
  import {
    needsKktState,
    resolveFfdVersion,
    resolveTaxVariantCodes,
  } from './kkmServerUnits'

  const EMPTY_KKT_STATE = Object.freeze({ loading: false, info: null, error: null })

  export default {
    name: 'KkmServerUnitsInfo',
    components: { FieldsGroup },
    data () {
      return {
        loading: false,
        kkmServerUnits: [],
        // Состояние ККТ по NumDevice: { loading, info, error }
        kktStates: {},
        error: null,
      }
    },
    created () {
      this.loadKkmServerUnits()
    },
    methods: {
      async loadKkmServerUnits () {
        this.loading = true
        try {
          this.kkmServerUnits = await kkmServerApiClient.getUnitsList()
        } catch (e) {
          this.error = e
        }
        this.loading = false

        await this.loadKktStates()
      },

      // По одному устройству за раз: параллельные команды в KkmServer повышают
      // риск его падения «Collection was modified».
      async loadKktStates () {
        const units = this.kkmServerUnits.filter(needsKktState)

        units.forEach((unit) => {
          this.$set(this.kktStates, unit.NumDevice, { loading: true, info: null, error: null })
        })

        for (const unit of units) {
          try {
            const info = await kkmServerApiClient.getDataKkt(unit.NumDevice)
            this.$set(this.kktStates, unit.NumDevice, { loading: false, info, error: null })
          } catch (e) {
            this.$set(this.kktStates, unit.NumDevice, {
              loading: false,
              info: null,
              error: e?.message || String(e),
            })
          }
        }
      },

      getKktState (unit) {
        return this.kktStates[unit.NumDevice] || EMPTY_KKT_STATE
      },

      getFfdVersion (unit) {
        return resolveFfdVersion(unit, this.getKktState(unit).info)
      },

      getTaxVariants (unit) {
        return resolveTaxVariantCodes(unit, this.getKktState(unit).info)
          .map((code) => TaxVariant.getName(code))
      },
    },
  }
</script>

<style scoped lang="less">

.kkmserver-unit-info {
  &__tax-item {
    font-size: 12px;
    line-height: 14px;
    height: 20px;
  }

  &__hint {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
